import React from 'react';
import { formatDate } from '../../lib/dateUtils';

interface TrialBalancePrintProps {
  data: {
    company: {
      name: string;
      address: string;
    };
    reportMeta: {
      fromDate: string;
      toDate: string;
    };
    items: {
      name: string;
      debit: number;
      credit: number;
      isGroup: boolean;
    }[];
    totalDebit: string;
    totalCredit: string;
  };
}

const TrialBalancePrint: React.FC<TrialBalancePrintProps> = ({ data }) => {
  return (
    <div className="print-report p-6 text-black font-sans text-[12px] bg-white ">
      {/* Header */}
      <div className="text-center border-b-2 border-black pb-4 mb-4">
        <h1 className="text-2xl font-bold uppercase">{data.company.name}</h1>
        <p className="text-[14px]">{data.company.address}</p>
        <h2 className="text-lg font-bold mt-2 underline">Trial Balance</h2>
        <p className="font-semibold">{formatDate(data.reportMeta.fromDate)} to {formatDate(data.reportMeta.toDate)}</p>
      </div>

      {/* Table */}
      <table className="w-full border-collapse border border-black">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-black px-4 py-2 text-left">Particulars</th>
            <th className="border border-black px-4 py-2 text-right w-[150px]">Debit</th>
            <th className="border border-black px-4 py-2 text-right w-[150px]">Credit</th>
          </tr>
        </thead>
        <tbody>
          {data.items.map((item, idx) => (
            <tr key={idx}>
              <td className={`border border-black px-4 py-1 ${item.isGroup ? 'font-bold uppercase tracking-wider' : 'pl-8'}`}>
                {item.name}
              </td>
              <td className="border border-black px-4 py-1 text-right font-semibold">
                {item.debit > 0 ? item.debit.toFixed(2) : ''}
              </td>
              <td className="border border-black px-4 py-1 text-right font-semibold">
                {item.credit > 0 ? item.credit.toFixed(2) : ''}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="bg-gray-50 font-bold text-[14px]">
            <td className="border border-black px-4 py-2 text-right uppercase tracking-widest">Grand Total</td>
            <td className="border border-black px-4 py-2 text-right">{data.totalDebit}</td>
            <td className="border border-black px-4 py-2 text-right">{data.totalCredit}</td>
          </tr>
        </tfoot>
      </table>

      {/* Footer */}
      <div className="mt-12 flex justify-between">
        <div className="text-center">
          <div className="border-t border-black w-32 mt-8 pt-1">Prepared By</div>
        </div>
        <div className="text-center">
          <div className="border-t border-black w-32 mt-8 pt-1">Authorised Signatory</div>
        </div>
      </div>
    </div>
  );
};

export default TrialBalancePrint;
